import { SERVICE, initialState } from "./constants";
export default {
	serviceId: localStorage.getItem(SERVICE) || null,
	checkinModel: initialState(),
	auxModel: initialState(),
	recommendedTime: false,
	dateReference: null,
	utm_source: null,
	isEditing:true,
	events:{key:"",data:{}}
};
